import { Modal } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useState } from "react";

const AttendanceDetailsModal = ({
  show,
  onHide,
  data,
  dateStr,
  getNurseDetailsForDate,
  formInputs,
  isReplacement,
  replacementNurseDetails,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  const toggleCard = () => setIsVisible(!isVisible);

  const originalNurse = getNurseDetailsForDate
    ? getNurseDetailsForDate(dateStr)
    : {};

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-eye-fill me-2"></i>
          Attendance Details
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "600px", overflowY: "auto" }}>
        {/* 🔹 SINGLE ACCORDION */}
        <div className="accordion" id="accordionAttendance">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} className="arrowBtn">
                  <i
                    className={`bi ${
                      isVisible ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCard}
                    style={{ cursor: "pointer" }}
                  ></i>
                </Col>

                <Col xs={2} className="text-center logoBtn">
                  <span className="iconLogo">AD</span>
                </Col>

                <Col xs={9}>
                  <span className="headerTitle">Attendance Details</span>
                  <span className="subHeaderTitle d-block">
                    Nurse & Daily Status Information
                  </span>
                </Col>
              </Row>
            </h2>

            <div
              className={`accordion-collapse collapse show ${
                isVisible ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                {/* 🟡 Replacement Nurse */}
                {isReplacement && replacementNurseDetails && (
                  <div className="mb-3 p-3 border rounded bg-light">
                    <h6 className="fw-bold text-warning mb-2">
                      Replacement Nurse
                    </h6>

                    <Row>
                      <Col md={6}>
                        <b>Name:</b>{" "}
                        {replacementNurseDetails.nurseName || "—"}
                      </Col>
                      <Col md={6}>
                        <b>Mobile:</b>{" "}
                        {replacementNurseDetails.mobileNr || "—"}
                      </Col>
                      <Col md={6}>
                        <b>User ID:</b>{" "}
                        {replacementNurseDetails.userId || "—"}
                      </Col>
                      <Col md={6}>
                        <b>Assoc No:</b>{" "}
                        {replacementNurseDetails.AssociateNumber || "—"}
                      </Col>
                    </Row>
                  </div>
                )}

                {/* 🔵 Assigned Nurse */}
                <div className="mb-3 p-3 border rounded bg-light">
                  <h6 className="fw-bold text-primary mb-2">
                    {isReplacement
                      ? "Originally Assigned Nurse"
                      : "Assigned Nurse"}
                  </h6>

                  <Row>
                    <Col md={6}>
                      <b>Name:</b>{" "}
                      {originalNurse?.nurseName ||
                        formInputs?.nurseName ||
                        "—"}
                    </Col>
                    <Col md={6}>
                      <b>Mobile:</b>{" "}
                      {originalNurse?.mobileNr ||
                        formInputs?.nurseMobileNr ||
                        "—"}
                    </Col>
                    <Col md={6}>
                      <b>User ID:</b>{" "}
                      {originalNurse?.userId ||
                        formInputs?.nurseUserId ||
                        "—"}
                    </Col>
                    <Col md={6}>
                      <b>Assoc No:</b>{" "}
                      {originalNurse?.AssociateNumber ||
                        formInputs?.nurseAssociateNumber ||
                        "—"}
                    </Col>
                  </Row>
                </div>

                {/* 🟢 Attendance */}
                <div className="p-3 border rounded bg-light">
                  <h6 className="fw-bold text-secondary mb-2">
                    Attendance Info
                  </h6>

                  <Row>
                    <Col md={4}>
                      <b>Date:</b> {dateStr}
                    </Col>
                    <Col md={4}>
                      <b>Day:</b> {data?.dayName || "—"}
                    </Col>
                    <Col md={4}>
                      <b>Status:</b>{" "}
                      <span
                        className="badge"
                        style={{
                          backgroundColor:
                            data?.status === "Present"
                              ? "#e8f8ee"
                              : data?.status === "Absent"
                              ? "#fff0f1"
                              : "#fff8e6",
                          color:
                            data?.status === "Present"
                              ? "#1a6b35"
                              : data?.status === "Absent"
                              ? "#c0392b"
                              : "#7d5a00",
                          border: "1px solid #ddd",
                          padding: "6px 10px",
                        }}
                      >
                        {data?.status || "—"}
                      </span>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AttendanceDetailsModal;